import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=0ec64c08&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"
import style0 from "./Items.vue?vue&type=style&index=0&id=0ec64c08&lang=scss&scoped=true&"
import style1 from "./Items.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec64c08",
  null
  
)

export default component.exports